import * as Yup from 'yup'

export const scanToEarnSchema = Yup.object().shape({
  barcode_value: Yup.string().required('validation-required'),
  summary: Yup.string().required('validation-required'),
  media: Yup.array()
    .min(2, 'scan-to-earn-media-validation-min')
    .max(10, 'scan-to-earn-media-validation-max'),
  company_name: Yup.string().required('validation-required').max(100, 'validation-max-length-100'),
  product_name: Yup.string().required('validation-required').max(100, 'validation-max-length-100'),
})
